<template>
  <div class="body-layout flex-vert">
    <header class="page-header">
      <slot name="page-header"></slot>
    </header>
    <div ref="ebsBody" class="ebs-body flex-space ebs-content">
      <slot name="ebs-content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BodyLayout',
}
</script>

<style scoped></style>
